import React, { useState, Fragment, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Grid,
  Backdrop,
  CircularProgress,
  Divider,
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
//Notificacion errores https://iamhosseindhv.com/notistack/demos#variants
import { useSnackbar } from "notistack";
//componentes del sistema
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useStylesApp } from "hooks/useStyles";
import Alert from "widgets/alert";
import { useSelector } from "react-redux";
import { getRUCEmpresa } from "redux/actions/userActions";
import { clientPay } from "configurations/axios";
import {
  API_POST_REGISTER_VOUCHER,
} from "../apis";
const useStyles = makeStyles((theme) => ({
  divForm: {
    marginBottom: "1%",
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    paddingLeft: "0.5%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  textFieldComboBox: {
    minWidth: "100%",
    maxWidth: "100%",
  },
}));

const RegistrarComprobantes = ({ updateView }) => {
  const classes = useStyles();
  const classesApp = useStylesApp();
  const classesGlobal = useStylesGlobal();
  const [openLoader, setOpenLoader] = useState(false);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  const [open, setOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState({});
  const userToken = useSelector((state) => state.user.tk);
  const { enqueueSnackbar } = useSnackbar();
  const [errors, setErros] = useState({});
  const [packet, setPacket] = useState({idPartner: getRUCEmpresa(userToken)});

  const handleClickOpen = () => {
    setOpen(true);
    setErros({});
    setSelectedCompany({});
  };

  const handleClose = () => {
    setOpen(false);
    setMsg({ show: false, msg: null, type: null });
  };
  function closeAlert() {
    setMsg({ show: false });
  }

  const handleChange = (event) =>{
    setPacket({
      ...packet,
      [event.target.name]: event.target.value
    });
  }

  const handleAddVouchers = async (event) => {
    let validations = {};
    setOpenLoader(true);
    event.preventDefault();
      if (
        packet.numeroComprobantesContratados === null ||
        typeof packet.numeroComprobantesContratados === "undefined"
      ) {
        validations.numeroComprobantesContratados = "Ingrese un número de comprobantes.";
      }
    if (Object.keys(validations).length === 0) {
      await clientPay
        .post(
          API_POST_REGISTER_VOUCHER, packet 
        )
        .then((response) => {
          enqueueSnackbar("Comprobantes asignados.", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            autoHideDuration: 10000,
          });
          updateView();
          handleClose();
          setOpenLoader(false);
        })
        .catch((exception) => {
          if (exception.response) {
            if (exception.response.status === 400) {
              setMsg({
                show: true,
                msg: "No se pudo asignar los comprobantes.",
              });
            } else {
              setMsg({
                show: true,
                msg:
                  "Error al asignar comprobantes a la empresa. Contáctese con el administrador del Sistema.",
              });
            }
          } else {
            setMsg({
              show: true,
              msg:
                "Existen problemas en la red. Contáctese con el administrador del Sistema.",
            });
          }
          setOpenLoader(false);
        });
    } else {
      setErros(validations);
      setOpenLoader(false);
    }
  };

  return (
    <Fragment>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        <AddCircleIcon
          style={{ color: palette.primary.contrastText, paddingRight: '3%' }}
          fontSize="small"
        />{"  "}
        Solicitar comprobantes adicionales
      </Button>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">
          Solicitar más comprobantes{" "}
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleAddVouchers}>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Grid item xs={12} md={12}>
                <label>
                  Los campos marcados con ({" "}
                  <font color={palette.error.main}> *</font> ) son obligatorios:
                </label>
              </Grid>
              {msgError.show ? (
                <Alert
                  tipo={msgError.type}
                  mensaje={msgError.msg}
                  mesajeSubrayado={null}
                  titulo={null}
                  mostrar={msgError.show}
                  cerrarAlerta={closeAlert}
                />
              ) : null}
              
              <Grid item xs={12} md={4}>
                Número de comprobantes a agregar: <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <input 
                type="number"
                value={packet.numeroComprobantesContratados}
                onChange={handleChange}
                name="numeroComprobantesContratados"
                className={
                  errors.numeroComprobantesContratados
                    ? "form-control is-invalid"
                    : "form-control"
                }>
                </input>
                {errors.numeroComprobantesContratados ? (
                  <p className={classesApp.errorLetters}>
                    {errors.numeroComprobantesContratados}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={4}>
                Tipo de contratación: <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <input 
                type="text"
                value={packet.tipoContratacion}
                onChange={handleChange}
                name="tipoContratacion"
                className={
                  errors.tipoContratacion
                    ? "form-control is-invalid"
                    : "form-control"
                }>
                </input>
                {errors.tipoContratacion ? (
                  <p className={classesApp.errorLetters}>
                    {errors.tipoContratacion}
                  </p>
                ) : null}
              </Grid>
              <Grid container spacing={3} justify="center">
                <Grid item md={12} xs={12}>
                  <Divider></Divider>
                </Grid>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classesGlobal.marginButton}
                >
                  Agregar
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  className={classesGlobal.marginButton}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
};

export default RegistrarComprobantes;
